import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import store from '../store.js'

let paths = [{
      path: '*',
      meta: { public: true },
      redirect: { path: '/404' }
    },
    {
      path: "/",
      meta: {},
      name: "root",
      redirect: {
        name: "inicio_busca"
      }
    },
    {
      path: '/404',
      meta: { public: false },
      name: 'not/found',
      component: () =>
        import (`@/views/NotFound.vue`)
    },
    {
      path: '/autenticacion',
      meta: { public: true },
      name: 'login',
      component: () =>
        import (`@/views/Login.vue`)
    },
    {
      path: '/cambio/clave',
      meta: { public: true },
      name: 'cambio',
      component: () =>
        import (`@/views/CambioClave.vue`)
    },
    {
      path: '/funciones',
      meta: { public: true },
      name: 'roles',
      component: () =>
        import (`@/views/Roles.vue`)
    },
    {
      path: '/inicio',
      meta: { public: true },
      name: 'inicio',
      component: () => import (`@/views/Inicio.vue`),
      children: [
      	{
          path: 'buscar',
          name: 'inicio_busca',
          component: () => import (`@/views/BuscaCentro.vue`),
        },
        {
          path: 'solicitud/apertura',
          name: 'inicio_solicitud_apertura',
          component: () => import (`@/views/SolicitudApertura.vue`),
        },
        {
          path: 'cursos',
          name: 'inicio_curso',
          component: () => import (`@/views/CursoInformacion.vue`),
        },
        {
          path: 'requisitos',
          name: 'inicio_requisito',
          component: () => import (`@/views/RequisitoTramite.vue`),
        },
        {
          path: 'estructura',
          name: 'inicio_estructura',
          component: () => import (`@/views/EstructuraPEI.vue`),
        },
      ]
    },
    {
      path: '/principal',
      meta: { public: false, requiresAuth: true },
      name: 'principal',
      component: () =>
        import (`@/views/Principal.vue`)
    },
    {
      path: '/facilitadores',
      meta: { public: false, requiresAuth: true },
      name: 'facilitador',
      component: () =>
        import (`@/views/Facilitador.vue`)
    },
    {
      path: '/personal/administrativo',
      meta: { public: false, requiresAuth: true },
      name: 'administrativo',
      component: () =>
        import (`@/views/PersonalAdministrativo.vue`)
    },
    {
      path: '/subsedes',
      meta: { public: false, requiresAuth: true },
      name: 'subsede',
      component: () =>
        import (`@/views/Subsede.vue`)
    },
    {
      path: '/sedecentral',
      meta: { public: false, requiresAuth: true },
      name: 'sedecentral',
      component: () =>
        import (`@/views/SedeCentral.vue`)
    },
    {
      path: '/propietarios',
      meta: { public: false, requiresAuth: true },
      name: 'propietario',
      component: () =>
        import (`@/views/Propietario.vue`)
    },
    {
      path: '/centros/capacitacion',
      meta: { public: false, requiresAuth: true },
      name: 'centros',
      component: () =>
        import (`@/views/Centro.vue`)
    },
    {
      path: '/cursos/capacitacion',
      meta: { public: false, requiresAuth: true },
      name: 'cursos',
      component: () =>
        import (`@/views/CursoCapacitacion.vue`)
    },
    {
      path: '/centros/nuevo',
      meta: { public: false, requiresAuth: true },
      name: 'centro_nuevo',
      component: () =>
        import (`@/views/CentroNuevo.vue`)
    },
    {
      path: '/solicitudes/apertura',
      meta: { public: false, requiresAuth: true },
      name: 'solicitudes/apertura',
      component: () =>
        import (`@/views/ListaApertura.vue`)
    },
    {
      path: '/tramite/verifica/departamental',
      meta: { public: false, requiresAuth: true },
      name: 'inspeccion_ocular',
      component: () =>
        import (`@/views/FiltroDepartamental.vue`)
    },
    {
      path: '/tramite/recepcion/departamental',
      meta: { public: false, requiresAuth: true },
      name: 'recepcion_departamental',
      component: () =>
        import (`@/views/FiltroDepartamental.vue`)
    },
    {
      path: '/tramite/notifica/departamental',
      meta: { public: false, requiresAuth: true },
      name: 'notificacion',
      component: () =>
        import (`@/views/NotificaDepartamental.vue`)
    },
    {
      path: '/tramite/verifica/nacional',
      meta: { public: false, requiresAuth: true },
      name: 'verifica_nacional',
      component: () =>
        import (`@/views/FiltroNacional.vue`)
    },
    {
      path: '/tramite/finaliza/nacional',
      meta: { public: false, requiresAuth: true },
      name: 'registro',
      component: () =>
        import (`@/views/FinalizaNacional.vue`)
    },
    {
      path: '/tramite/nuevo',
      meta: { public: false, requiresAuth: true },
      name: 'tramite/nuevo',
      component: () =>
        import (`@/views/TramiteNuevo.vue`)
    },
    {
      path: '/tramite/recibido',
      meta: { public: false, requiresAuth: true },
      name: 'tramite/recibido',
      component: () =>
        import (`@/views/TramiteRecibido.vue`)
    },
    {
      path: '/tramite/enviado',
      meta: { public: false, requiresAuth: true },
      name: 'tramite/enviado',
      component: () =>
        import (`@/views/TramiteEnviado.vue`)
    },
    {
      path: '/tramite/concluido',
      meta: { public: false, requiresAuth: true },
      name: 'tramite/concluido',
      component: () =>
        import (`@/views/TramiteConcluido.vue`)
    },
    {
      path: '/tramite/seguimiento',
      meta: { public: false, requiresAuth: true },
      name: 'tramite/seguimiento',
      component: () =>
        import (`@/views/TramiteSeguimiento.vue`)
    },
    // {
    //   path: '/tramite/apertura',
    //   meta: { public: true, requiresAuth: false },
    //   name: 'tramite/apertura',
    //   component: () =>
    //     import (`@/views/SolicitudApertura.vue`)
    // },
    {
      path: '/tramite/reingreso/apertura',
      meta: { public: false, requiresAuth: true },
      name: "solicita_apertura",
      component: () =>
        import (`@/views/AperturaDevolucion.vue`)
    },
    {
      path: '/tramite/subsede',
      meta: { public: false, requiresAuth: true },
      name: 'tramite_apertura_subsede',
      component: () =>
        import (`@/views/AperturaSubsede.vue`)
    },
    {
      path: '/tramite/inicio',
      meta: { public: false, requiresAuth: true },
      name: 'tramite_inicio',
      component: () =>
        import (`@/views/IniciaTramite.vue`)
    },
    {
      path: '/tramite/inicio',
      meta: { public: false, requiresAuth: true },
      name: "modifica",
      redirect: {
        name: "tramite_inicio"
      }
    },
    {
      path: '/perfil',
      meta: { public: false, requiresAuth: true },
      name: 'perfil',
      component: () => import(`@/views/Usuario.vue`)
    },
    /* by neko*/
    {
      path: '/academico/cursoacademico',
      meta: { public: false, requiresAuth: true },
      name: 'academico/cursoacademico',
      component: () => import(`@/views/CursoGestion.vue`)
    },
    {
      path: '/academico/inscripcion',
      meta: { public: false, requiresAuth: true },
      name: 'academico/inscripcion',
      component: () => import(`@/views/InscripcionGestion.vue`)
    },
    {
      path: '/academico/notas',
      meta: { public: false, requiresAuth: true },
      name: 'academico/notas',
      component: () => import(`@/views/NotasGestion.vue`)
    },
    /*{
      path: '/academico/certificacion',
      meta: { public: false, requiresAuth: true },
      name: 'academico/certificacion',
      component: () => import(`@/views/Usuario.vue`)
    },*/
    {
      path: '/reporte/repinscritos',
      meta: { public: false, requiresAuth: true },
      name: 'reporte/repinscritos',
      component: () => import(`@/views/RepInscritos.vue`)
    },
    {
      path: '/reporte/reppersonal',
      meta: { public: false, requiresAuth: true },
      name: 'reporte/reppersonal',
      component: () => import(`@/views/RepPersonal.vue`)
    },
    {
      path: '/reporte/repcursos',
      meta: { public: false, requiresAuth: true },
      name: 'reporte/repcursos',
      component: () => import(`@/views/RepCursos.vue`)
    },
    {
      path: '/curso/nuevo',
      meta: { public: false, requiresAuth: true },
      name: 'curso/nuevo',
      component: () => import(`@/views/CursoNuevo.vue`)
    },
    /*{
      path: '/academico/inscripcionNuevo',
      meta: { public: false, requiresAuth: true },
      name: 'curso/nuevo',
      component: () => import(`@/views/DetalleInscripcion.vue`)
    },*/
    {
      path: '/reporte/repinscritosdep',
      meta: { public: false, requiresAuth: true },
      name: 'reporte/repinscritosdep',
      component: () => import(`@/views/RepInscritosDep.vue`)
    },
    {
      path: '/reporte/repcursosdep',
      meta: { public: false, requiresAuth: true },
      name: 'reporte/repcursosdep',
      component: () => import(`@/views/RepCursosDep.vue`)
    },
    {
      path: '/reporte/repindidep',
      meta: { public: false, requiresAuth: true },
      name: 'reporte/repindidep',
      component: () => import(`@/views/RepIndiDep.vue`)
    },
    {
      path: '/reporte/repinscritosnal',
      meta: { public: false, requiresAuth: true },
      name: 'reporte/repinscritosnal',
      component: () => import(`@/views/RepInscritosNal.vue`)
    },
    {
      path: '/reporte/repcursosnal',
      meta: { public: false, requiresAuth: true },
      name: 'reporte/repcursosnal',
      component: () => import(`@/views/RepCursosNal.vue`)
    },
    {
      path: '/reporte/repindinal',
      meta: { public: false, requiresAuth: true },
      name: 'reporte/repindinal',
      component: () => import(`@/views/RepIndiNal.vue`)
    },
    
];
Vue.use(Router);
const router = new Router({
    base: '/',
    mode: 'hash',
    linkActiveClass: 'active',
    routes: paths
});

router.afterEach(() => {
    NProgress.done();
});
const openRoutes = ['login'];
router.beforeEach((to, from, next) => {
    NProgress.start();
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            next();
            return;
        }
        next('/autenticacion');
    } else {
        next();
    }
    /* if(openRoutes.includes(to.name)) {
      next()
    } else if (store.getters.isAuthenticated){
      next()
    } else {
      next('/autenticacion')
    } */
});

export default router;